import { type PaidCreditTier } from '../../models/Plan'

export const tierForQuantity = (tiers: PaidCreditTier[], quantity: number): PaidCreditTier | null => {
  let best: PaidCreditTier | null = null
  for (const tier of tiers) {
    if (tier.minQuantity <= quantity && (best === null || tier.minQuantity > best.minQuantity)) {
      best = tier
    }
  }
  return best
}

export const nextTierAbove = (tiers: PaidCreditTier[], quantity: number): PaidCreditTier | null => {
  let next: PaidCreditTier | null = null
  for (const tier of tiers) {
    if (tier.minQuantity > quantity && (next === null || tier.minQuantity < next.minQuantity)) {
      next = tier
    }
  }
  return next
}

export const lowestMinQuantity = (tiers: PaidCreditTier[]): number | null =>
  tiers.length === 0 ? null : tiers.reduce((min, tier) => Math.min(min, tier.minQuantity), Infinity)
